import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  .HomeContent {
    background-color: #FFFFFF;
    padding: 30px 0;
    text-align: center;
    @media (min-width: 992px) {
      padding: 90px 0;
    }
  }
  .HomeContent_heading {
    font-size: 28px;
    font-family: ${typography.Serif};
    margin: 0 0 20px 0;
    line-height: 1;
    color: ${colors.color1Dark};
    @media (min-width: 992px) {
      font-size: 40px;
    }
  }
  .HomeContent_postHeading {
    font-weight: normal;
    display: block;
    font-size: 16px;
    font-family: ${typography.SansSerif};
    text-transform: uppercase;
    letter-spacing: 2px;
    color: ${colors.color2};
    margin: 20px 0;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
`;

function HomeContent({ page }) {
  return (
    <div className={styles}>
      <div className="HomeContent">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              {
                page.home_content[0].title &&
                <h1 className="HomeContent_heading">
                  {page.home_content[0].title}
                  {
                    page.home_content[0].post_title &&
                    <span className="HomeContent_postHeading">{page.home_content[0].post_title}</span>
                  }
                </h1>
              }
              {
                get(page, 'home_content[0].body') &&
                <div className="HomeContent_body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'home_content[0].body'))} />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeContent.propTypes = {
  page: PropTypes.object.isRequired,
};

HomeContent.defaultProps = {
  page: undefined,
};

export default HomeContent;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeContent.js